import { Unit } from '../../../../instructor/units.service';
import { unitDisplayName } from './unit-display-name';

/**
 * Builds a minimal Course-shaped object from a single Unit for instructor preview
 * mode when no real courseId is available (e.g. previewing a unit from the Content
 * Hub library where the unit may not belong to any course).
 *
 * The resulting object matches enough of the Course shape for the learner modal
 * chrome (title, description) without fabricating server-owned fields such as
 * startedAt, completedAt, or enrollment status.
 */
export function buildPreviewCourseShell(unit: Unit): {
  id: string;
  title: string;
  name: string;
  description: string;
  organizationId: string;
  // Learner modal checks this to decide returning-learner state; preview = never started.
  startedAt: null;
  // Preview previews a single unit — no free-nav or certificate concerns.
  freeNavigation: false;
  units: Unit[];
} {
  const displayName = unitDisplayName(unit);
  return {
    id: `preview-${unit.id}`,
    title: displayName,
    name: displayName,
    description: unit.description || '',
    organizationId: unit.organizationId,
    startedAt: null,
    freeNavigation: false,
    units: [unit],
  };
}
